export default "__VITE_ASSET__lP6ZzkhD__"